import { connect } from 'react-redux';
import { logout, saveLocale } from 'actions';
import { showASQModal } from 'actions/internal';
import FixedBar from 'components/nav/FixedBar';
import { scrollPosition } from 'utils/scrollHelpers';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onLogout: () => {
      dispatch(logout())
    },
    onStartASQ: () => {
      dispatch(showASQModal(ownProps.withPlayer || false, ownProps.withPlayer ? null: scrollPosition()))
    },
    onSaveLocale: (locale, previousLocale) => {
      dispatch(saveLocale(locale, previousLocale))
    },
  }
}

const TopNavBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(FixedBar)

export default TopNavBar;
